import ledgerAccountCategoryIds from './ledgerAccountCategoryIds';

const ledgerAccountCategoryOrderById = {
  [ledgerAccountCategoryIds.ASSETS]: 0,
  [ledgerAccountCategoryIds.LIABILITIES]: 1,
  [ledgerAccountCategoryIds.EQUITY]: 2,
  [ledgerAccountCategoryIds.EQUITY]: 3,
  [ledgerAccountCategoryIds.COST_OF_SALES]: 4,
  [ledgerAccountCategoryIds.OPERATING_EXPENSES]: 5,
};

export default ledgerAccountCategoryOrderById;
